module.exports = __webpack_public_path__ + "media/cyclone2.38f46147.webm";